<template>
  <div
    class="text-image-block overflow py-8 lg:py-16"
    :class="[model.background, model.textColor ? model.textColor : 'text-[color:var(--color-body-text)]']"
  >
    <div class="container mx-auto max-w-screen-2xl">
      <div
        class="mx-auto flex w-full flex-col items-center lg:flex-row"
        :class="[model.imagePosition === `right` ? `lg:flex-row-reverse` : ``]"
      >
        <div
          class="mb-6 flex w-full flex-1 flex-col items-start"
          :class="[model.imagePosition === `right` ? `md:items-end` : ``]"
        >
          <VcImage class="w-full rounded-lg object-cover" :src="model.image" />
        </div>
        <div class="flex flex-1 flex-wrap">
          <div>
            <component
              :is="model.heading"
              v-if="model.title"
              class="mb-2 font-bold"
              :class="[model.imagePosition === `right` ? `lg:pr-12` : `lg:pl-12`]"
            >
              {{ model.title }}
            </component>
            <div
              v-if="contentValue"
              :class="[model.imagePosition === `right` ? `lg:pr-12` : `lg:pl-12`]"
              class="block-content mb-6 text-lg leading-9"
              v-html-safe="contentValue"
            ></div>

            <VcButton
              v-if="showTheButton"
              v-bind="getLinkAttr(model.buttonUrl)"
              class="w-1/2 px-8 lg:w-auto"
              :class="[model.imagePosition === `right` ? `lg:mr-12` : `lg:ml-12`]"
            >
              {{ model.buttonLabel }}
            </VcButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const contentValue = computed(() => {
  return props.model.text as string;
});

const showTheButton = computed(() => {
  return Boolean(props.model.buttonLabel) && Boolean(props.model.buttonUrl);
});
</script>

<style lang="scss" scoped></style>
